import { AdaptiveCard, GlobalRegistry, GlobalSettings, HostConfig } from 'adaptivecards';

import { RatingInput } from '../../RatingInput';
import { RecommendationInput } from '../../RecommendationInput';
import { TextWithLimit } from '../../TextWithLimit';

export const createAdaptiveCard = (adaptiveCardJson, hostConfig) => {
	GlobalSettings.useMarkdownInRadioButtonAndCheckbox = false;
	GlobalRegistry.elements.register('Input.Rating', RatingInput);
	GlobalRegistry.elements.register('Input.Recommendation', RecommendationInput);
	GlobalRegistry.elements.register('Input.TextWithLimit', TextWithLimit);

	const adaptiveCard = new AdaptiveCard();
	adaptiveCard.parse(adaptiveCardJson);
	adaptiveCard.hostConfig = new HostConfig(hostConfig);

	return adaptiveCard;
};

export const removeFirstChild = (cardRef) => {
	if (cardRef.current.firstChild) {
		cardRef.current.removeChild(cardRef.current.firstChild);
	}
};

export const removeCharacterCount = (json) => {
	if (!json || typeof json !== 'object') return;

	if (Array.isArray(json)) {
		json.forEach(removeCharacterCount);
		return;
	}

	if (json.type === 'Input.TextWithLimit') {
		// eslint-disable-next-line no-undefined
		json.maxLength = undefined;
		json.hideCounter = true;
	}

	Object.values(json).forEach(removeCharacterCount);
};
